module.exports = __webpack_public_path__ + "img/bell_icon.16f28516.svg";